var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b2b-login-form-hipoges"},[_c('b2b-login-form-generic',{attrs:{"css":_vm.css,"logo":_vm.logo,"next":_vm.next,"localproject":_vm.localproject,"logomenu":_vm.logomenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }